import axios from 'axios';

// Va por el mismo origen (nginx enruta /contratos/ al servicio) → sin CORS.
const apiContratos = axios.create({ baseURL: '/contratos', timeout: 8000 });

apiContratos.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default apiContratos;

/**
 * Envuelve una llamada al servicio de contratos.
 * Devuelve {ok, data, caido} en vez de lanzar: la ficha del cliente NO puede romperse
 * porque este servicio esté caído. Es el objetivo entero del stack separado.
 *
 * Nota: a propósito NO hay interceptor de respuesta que redirija a /login ante un 401
 * (como sí hace apiv1.js). Si el servicio de contratos devuelve 401 por cualquier motivo,
 * expulsar al usuario del panel entero sería exactamente el acoplamiento que evitamos.
 */
export async function contratosSafe(fn) {
  try {
    const r = await fn();
    return { ok: true, data: r.data, caido: false };
  } catch (e) {
    const caido = !e.response || e.code === 'ECONNABORTED' || e.response.status >= 500;
    return { ok: false, data: null, caido };
  }
}
